<ng-container *ngIf="ticketDetails$ | async as ticket; else spinner">
    <div class="cx-ticket-details">
      <div class="container">
        <div class="cx-details-card">
          <cx-card
            [content]="
              prepareCardContent(ticket.id, 'customerTicketing.ticketId') | async
            "
          ></cx-card>
        </div>

        <div class="cx-details-card">
          <cx-card
            [content]="
              prepareCardContent(
                ticket.associatedTo ? ticket.associatedTo.code : '—',
                'customerTicketing.associatedTo'
              ) | async
            "
          ></cx-card>
        </div>

        <div class="cx-details-card">
          <cx-card
            [content]="
              prepareCardContent(
                ticket.ticketCategory ? (ticket.ticketCategory.name | cxTranslate) : undefined,
                'customerTicketing.category'
              ) | async
            "
          ></cx-card>
        </div>

        <div class="cx-details-card">
          <cx-card
            [content]="
              prepareCardContent(
                ticket.ticketPurchaseOrderNumber ? ticket.ticketPurchaseOrderNumber : '—',
                'customerTicketing.ticketPurchaseOrderNumber'
              ) | async
            "
          ></cx-card>
        </div>

        <div class="cx-details-card">
          <cx-card
            [content]="
              prepareCardContent(
                (ticket.ticketEvents?.[0]?.createdAt | cxDate: dateFormat) ?? '—',
                'customerTicketing.createdOn'
              ) | async
            "
          ></cx-card>
        </div>

        <div class="cx-details-card">
          <cx-card
            [content]="
              prepareCardContent(
                (ticket.modifiedAt | cxDate: dateFormat) ?? '—',
                'customerTicketing.changedOn'
              ) | async
            "
          ></cx-card>
        </div>

        <div class="cx-details-card">
          <cx-card
            [content]="
              prepareCardContent(
                ticket.status ? ticket.status.name : undefined,
                'customerTicketing.status',
                ticket.status ? ticket.status.id : undefined
              ) | async
            "
          ></cx-card>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #spinner>
    <cx-spinner></cx-spinner>
  </ng-template>
